import type { ConversationAct } from '@newo/api-client';
import type { NotificationPayload } from '@/types/agent-realtime';
import type { CreatorChatFlowMessage } from '@/types/creator-chat-flow';

const getCreatorChatFlowMessageRole = (
	referenceIdn: ConversationAct['reference_idn']
) => {
	if (referenceIdn === 'user_message') {
		return 'user';
	}

	if (referenceIdn === 'agent_message') {
		return 'agent';
	}

	return null;
};

export const normalizeCreatorChatFlowMessages = (
	acts: ConversationAct[]
): CreatorChatFlowMessage[] => {
	return [...acts]
		.sort((left, right) => {
			return (
				new Date(left.datetime).getTime() - new Date(right.datetime).getTime()
			);
		})
		.reduce<CreatorChatFlowMessage[]>((messages, act) => {
			const role = getCreatorChatFlowMessageRole(act.reference_idn);
			const text =
				act.source_text ?? act.original_text ?? act.english_text ?? '';

			if (!role || !text.trim()) {
				return messages;
			}

			messages.push({
				id: act.id,
				role,
				text: text.trim()
			});

			return messages;
		}, []);
};

export const normalizeCreatorChatFlowNotification = (
	notification: NotificationPayload
): CreatorChatFlowMessage | null => {
	const text = notification.text.trim();

	if (!text) {
		return null;
	}

	return {
		id: notification.act_id,
		role: 'agent',
		text
	};
};
